<<template>
  <div @keyup.enter="search" ref="paramPanel" class="param-panel form-inline" :style="tstyle">
    <div class="param-list">
      <div  v-for='param in config.params' v-show='!(param.more && !isShow)' class="param-group input-group col-md-2">
        <label class="input-group-addon" >{{rs[param.tkey||param.key]}}</label>
        <input v-if='param.type=="text"' @input="param.onchange && param.onchange(param, config)" type="text" v-model="param.data" class="form-control" />
        <input v-else-if='param.type=="number"' @input="param.onchange && param.onchange(param, config)" type="number" class="form-control" v-model="param.data"/>
        <date-input v-else-if='param.type=="date"' @change="param.onchange && param.onchange(param, config)" class="form-control" v-model="param.data"/>
        <DatePicker v-else-if='param.type=="month"' :format="param.format || 'yyyy-MM'" type="month" placeholder="月份选择" :value="param.init && param.init()" @on-change="param.onchange && param.onchange($event, param, config)"></DatePicker>
        <select v-else-if='isSelect(param)' @change="param.onchange && onParamChange(param, config)" v-model="param.data" class="form-control">
          <option v-for='(item, index) in getOptions(param.options)' :selected="index==0" :value="item.value">{{item.rsText? rs[item.rsText]:item.text}}</option>
        </select>
        <input v-else type="text" @input="param.onchange && param.onchange(param, config)" v-model="param.data" class="form-control" />
      </div>
      <slot></slot>
      <div class="param-group">
        <div class="btn-group dropup">
          <button type="button" class="btn btn-default" @click.stop='search'>{{rs["param_btn_search"]}}</button>
          <button v-if="config.isShowMore" v-on:click.stop="showMore" :title="moreTitle" style="padding: 6px 3px;" type="button" class="btn btn-default">{{moreText}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<<script>
//import {DatePicker} from 'element-ui'

export default {
  //updated() {
  //  console.log("paramPanel.created")
  //},
  
  props:["config", "rs"],
  data(){
    return {
      isShow: false,
      moreTitle: this.rs["param_btn_search_more"],
      moreText: ">>",
      isNeedUpdate: false
    }
  },
  computed:{
    tstyle(){
      return this.isShow ? "padding: 0 0 10px 0;":""
    }
  },
  methods: {
    onParamChange(p, c){
      p.onchange.call(this, p, c)
    },
    search: function(){
      this.config.sortName = this.config.defaultSortName || this.config.sortName
      this.config.sortOrder = this.config.defaultSortOrder || this.config.sortOrder
      this.config.sortColumn = null
      this.$loadData(this.config, 1)
    },
    showMore(){
      this.isShow = !this.isShow
      if (this.isShow) {
        this.moreTitle = this.rs["param_btn_search_more_hide"]
        this.moreText = "<<"
      }
      else {
        this.moreTitle = this.rs["param_btn_search_more"]
        this.moreText = ">>"
      }
      //setTimeout(() => {
        //const pp = $(".param-panel:first")
        //const ps = pp.find(".param-list:first")
        //pp.css("min-height", ps.height())
      //}, 10)
      //this.isNeedUpdate=true
    },
    getOptions(dt){
      if (typeof dt == "string"){
        //console.log(this.config[dt])
        if (this.config[dt]) return this.config[dt]
      }
      else return dt
    },
    isSelect(param){
      if (param.type=="select"){
        if(!param.data && param.defaultIdx>=0) {
          let o = this.getOptions(param.options)
          if (o) o=o[param.defaultIdx]
          if (o && o.value) param.data=o.value
        }
        return true
      }
      return false
    }
  },
  updated(){
    if (this.isNeedUpdate){
      this.isNeedUpdate = false
      //this.$initListPanelHeight()
      window.fuiInitListPanelHeight()
    }
  }
  //, components:{
  //  "el-date-picker": DatePicker
  //}
}
</script>
